import { Divider, Flex, Paper } from "@mantine/core";
import { useDispatch } from "react-redux";
import {
  setGroupByValue,
  setSelectValue,
  useSelectAuditTrailGroupByValue,
  useSelectAuditTrailSelectValue,
} from "../../../redux/features/auditTrail/auditTrailSlice";
import { buildOptions, CRITERIA_KIND } from "../constants";
import SelectGroupSection from "./SelectGroupSection";
import { useDropdownDataQuery } from "./useAuditTrailQueries";

const AuditTrailCriteria = () => {
  const dispatch = useDispatch();
  const selectValue = useSelectAuditTrailSelectValue();
  const groupByValue = useSelectAuditTrailGroupByValue();
  const { data: dropdownData } = useDropdownDataQuery();

  const options = buildOptions(dropdownData);

  return (
    <Paper mt="sm" p="md" radius="md" withBorder shadow="xs">
      <Flex
        direction={{ base: "column", md: "row" }}
        align="stretch"
        gap="md"
      >
        <SelectGroupSection
          kind={CRITERIA_KIND.SELECT}
          options={options}
          ownValue={selectValue}
          otherValue={groupByValue}
          onChange={(v) => dispatch(setSelectValue(v))}
        />
        <Divider
          orientation="vertical"
          visibleFrom="md"
          color="gray.3"
        />
        <Divider hiddenFrom="md" color="gray.3" />
        <SelectGroupSection
          kind={CRITERIA_KIND.GROUP}
          options={options}
          ownValue={groupByValue}
          otherValue={selectValue}
          onChange={(v) => dispatch(setGroupByValue(v))}
        />
      </Flex>
    </Paper>
  );
};

export default AuditTrailCriteria;
